import { render } from "./ClassDetailsTableRow.vue?vue&type=template&id=5554b709&scoped=true&ts=true"
import script from "./ClassDetailsTableRow.vue?vue&type=script&lang=ts"
export * from "./ClassDetailsTableRow.vue?vue&type=script&lang=ts"

import "./ClassDetailsTableRow.vue?vue&type=style&index=0&id=5554b709&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5554b709"]])

export default __exports__